import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import CheckCircleIcon from "@icons/myicons/check-circle-filled.svg?react";
const SCREEN_BREAKPOINT = 720;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  ${({ theme }) => theme.breakpoints.down(SCREEN_BREAKPOINT)} {
    padding-left: ${({ theme }) => theme.spacing(8.5)};
    margin-top: ${({ theme }) => theme.spacing(1)};
  }
`;

export const NoUpdateRequired = () => {
  const { t } = useTranslation();

  return (
    <>
      <Container>
        <Box display="flex" alignItems="center" color="icon.success">
          <CheckCircleIcon width="20px" height="20px" />
        </Box>
        <Typography variant="body3" color="textSecondary">
          {t("synchronizationLog.noUpdateRequired")}
        </Typography>
      </Container>
    </>
  );
};
